export const en = {
    "deny-access": "Deny access",
    "error": "An error has occurred.",
    "error-only-private": "Available only for published private skills.",
    "header": "Access",
    "links-button-copy": "Copy",
    "links-button-copy-tooltip": "Copied",
    "links-button-generate": "Generate",
    "links-descr": "Generate a link to grant access to a private skill. After the first use\nthe link will become invalid.",
    "links-header": "One-time links",
    "menu-links": "Links",
    "menu-users": "Users",
    "users-button-reload": "Reload",
    "users-deleted": "The user has been deleted",
    "users-descr": "A list of users who have access to a private skill. Access can be revoked at any time.",
    "users-only-you": "The skill is only available to you."
} as const;
export const ru = {
    "deny-access": "Запретить доступ",
    "error": "Произошла ошибка.",
    "error-only-private": "Доступно только для опубликованных приватных навыков.",
    "header": "Доступ",
    "links-button-copy": "Скопировать",
    "links-button-copy-tooltip": "Скопировано",
    "links-button-generate": "Сгенерировать",
    "links-descr": "Сгенерируйте ссылку, чтобы предоставить доступ к приватному навыку. После первого использования\n                ссылка станет недействительной.",
    "links-header": "Одноразовые ссылки",
    "menu-links": "Ссылки",
    "menu-users": "Пользователи",
    "users-button-reload": "Перезагрузить",
    "users-deleted": "Пользователь удален",
    "users-descr": "Список пользователей, имеющих доступ к приватному навыку. Доступ можно отозвать в любой  момент.",
    "users-only-you": "Навык доступен только вам."
} as const;